import React from 'react';
import PropTypes from 'prop-types';

import Togglable from '../togglable';

const ErrorMessage = Togglable(({ message, messageColour }) => (
	<p className={"text-"+messageColour}>{message}</p>
))

const TimelineMetadata = Togglable(({ timestamp }) => <p className="mb-0">Timeline: <span className="text-black-secondary">{timestamp}</span></p>)
const GeneralMetadata = Togglable(({ timestamp }) => <p className="mb-0">General</p>)

const typeInfo = {
	"public": {
		"label": "Public",
		"description": "Visible to everyone",
		"explanation": "Posting to anyone who can see this media item in this course"
	},
	"course": {
		"label": "Course",
		"description": "Visible to everyone in this course",
		"explanation": "Posting to anyone who who is enrolled in this course"
	},
	"feedback": {
		"label": "Feedback",
		"description": "Visible to you and your instructors",
		"explanation": "Posting to the owners of this media item"
	},
	"personal": {
		"label": "Personal",
		"description": "Visible to you only",
		"explanation": "Posting notes to yourself"
	}
};

const ReadOnlyMetadata = Togglable(({ isTimelineComment, timestamp, commentType }) => (
	<div className="form-group">
		<div className="row">
			<div className="col-sm">
				<TimelineMetadata visible={isTimelineComment} timestamp={timestamp} />
				<GeneralMetadata visible={!TimelineMetadata} />
			</div>
			<div className="col-sm mt-2 mt-sm-0">
				<p className="mb-0">{typeInfo[commentType].label} <span className="text-black-secondary">{typeInfo[commentType].description}</span></p>
			</div>
		</div>
	</div>
))

const EditTimestamp = Togglable(({ timestamp, updateCommentField }) => (
	<div className="form-text" id="collapse-comment-timeline">
		<div className="floating-label textfield-box has-value">
			<label htmlFor="input-comment-timeline">Timeline</label>
			<input className="form-control" id="input-comment-timeline" type="text" value={timestamp} onChange={({target:{value}})=>updateCommentField("timestamp", value)} />
		</div>
	</div>
))

const EditTimeline = Togglable(({ isTimelineComment, timestamp, updateCommentField }) => (
	<div className="form-group">
		<div className="row">
			<div className="col-sm">
				<div className="custom-control custom-radio">
					<input checked={!isTimelineComment} className="custom-control-input" id="radio-comment-general" name="radio-comment-type" type="radio" onChange={()=>updateCommentField("bTimelineComment", false)} />
					<label className="custom-control-label" htmlFor="radio-comment-general">General</label>
				</div>
			</div>
			<div className="col-sm">
				<div className="custom-control custom-radio">
					<input checked={isTimelineComment} className="custom-control-input" id="radio-comment-timeline" name="radio-comment-type" type="radio" onChange={()=>updateCommentField("bTimelineComment", true)} />
					<label className="custom-control-label" htmlFor="radio-comment-timeline">Timeline</label>
				</div>
			</div>
		</div>{isTimelineComment}
		<EditTimestamp visible={isTimelineComment} timestamp={timestamp} updateCommentField={updateCommentField} />
	</div>
))

const Option = Togglable(({ type, selected }) => (
	<option selected={selected} value={type}>{typeInfo[type].label}</option>
))

const EditCommentType = Togglable(({ commentType, allowAdd, updateCommentField }) => (
	<div className="form-group">
		<div className="floating-label textfield-box has-value">
			<label htmlFor="select-comment-type">Comment type</label>
			<select aria-describedby="select-comment-type-help" className="form-control" id="select-comment-type" onChange={({target:{value}})=>updateCommentField('comment_type', value)}>
				<Option visible={allowAdd.public} selected={commentType==="public"} type="public" />
				<Option visible={allowAdd.course} selected={commentType==="course"} type="course" />
				<Option visible={allowAdd.feedback} selected={commentType==="feedback"} type="feedback" />
				<Option visible={allowAdd.personal} selected={commentType==="personal"} type="personal" />
			</select>
		</div>
	</div>
))

const CreateForm = ({ actionlabel, values, user, duration, message, message_colour, allow_add, updateCommentField, saveComment }) => (
	<>
		<div className="form-group">
			<label className="sr-only" htmlFor={"new_gui_comment_"+values.comment_type+"_add_textarea"}>Reply comment</label>
			<textarea className="form-control" id={"new_gui_comment_"+values.comment_type+"_add_textarea"} placeholder="Add a comment" rows="3" value={values.body} onChange={({target:{value}})=>updateCommentField("body", value)} />
			<small id="passwordHelpBlock" className="form-text text-muted">{typeInfo[values.comment_type].description}</small>
			<ErrorMessage visible={message} message={message} messageColour={message_colour} />
		</div>
		<ReadOnlyMetadata visible={!values.timestamp_editable} isTimelineComment={values.bTimelineComment} timestamp={values.timestamp} commentType={values.comment_type} /> 
		<EditTimeline visible={values.timestamp_editable} isTimelineComment={values.bTimelineComment} timestamp={values.timestamp} updateCommentField={updateCommentField} />
		<EditCommentType visible={values.timestamp_editable} commentType={values.comment_type} updateCommentField={updateCommentField} allowAdd={allow_add} />
	</>
)

CreateForm.propTypes = {
	values: PropTypes.object.isRequired,
	user: PropTypes.object.isRequired,
	updateCommentField: PropTypes.func.isRequired,
	saveComment: PropTypes.func.isRequired
}

export default CreateForm;